<template>
  <div class="container">
    <div class="mian" >
      <video  id="video" class="mian" :src="url[index]" poster="posterimage.jpg" @click="playVideo">
        <source :src="url[index]" type="video">
        <!-- <source :src="url" type="video/ogg"> -->
        <!-- <source :src="url" type="video/quicktime"> -->
        您的浏览器不支持 video 标签。
      </video>
      <img class="video_icon" src="../../assets/images/video.png" alt="" @click="playVideo">
    </div>
  </div>
</template>

<script>
import storage from "../../utils/storage";
export default {
  name:"viewImage",
  components: {
  },
  data () {
    return {
      url:[],
      index:''
    }
  },
  created(){
    this.index = this.$route.query.index
    let fileList = JSON.parse(storage.get("viewImgList"))
    for (let i = 0; i < fileList.length; i++) {
      if(fileList[i].postfix.indexOf('mp4')!=-1){
        this.url.push(fileList[i].path)
      }
    }
    console.log(this.url);
    console.log(this.$route.query.index);

  },
  mounted(){
    let video = document.getElementById("video");
    video.play();
  },
  methods: {
    back(){
      window.history.back(-1);
    },
    playVideo() {
      var video = document.getElementById("video");
      video.play();
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";
.container{
  width: 100%;
  height: 100%;
  background: #000;
}
.mian{
  width:100%;
  height: 100%;
  position: relative;
}
.video_icon{
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
  width: 124px;
  height: 124px;
}
</style>
